import React from "react";

import { Form, Formik } from "formik";
import {
  Resiliation,
  recapSchema
} from "modules/resiliation/model/resiliation";
import { isMobile } from "react-device-detect";
import EditComponent from "shared/components/edit-component/edit-component";
import { SpbRecaptcha } from "shared/components/spb-recaptcha/spb-recaptcha";
import { FormulaireSubmit } from "./formulaire-submit";
import "./formulaire.scss";

export interface IFormulaireRecapProps {
  resiliation: Resiliation;
  recaptcha: string;
  submit: (resiliation: Resiliation) => void;
  cancel: () => void;
  goToStep: (step: any) => void;
  inProgress?: boolean;

}

const recapIcone: string =
  require("../../../../assets/recap-sinistre.svg").default;
const motif = {
  MAINTENANT: 'Maintenant',
  PROCHAINEECHANCE: 'Prochaine échéance'
}

export const FormulaireRecap = ({
  resiliation,
  submit,
  cancel,
  goToStep,
  recaptcha,
  inProgress,

}: IFormulaireRecapProps) => {
  return (
    <div>
      <div className={isMobile ? 'content-mobile' : 'content'}>
        <div className="container-box">
          <div className="avatar pt-5 pb-2 ps-2 ">
            <span className="fw-bold">
              <img src={recapIcone}></img>Récapitulatif de votre demande
            </span>
          </div>
          <div className="d-flex justify-content-between flex-wrap">
            <EditComponent
              informations={resiliation?.informations}
              label="Etape 1 : Identité de l’adhérent"
              goToStep={() => goToStep(0)}

            />
            <EditComponent
              informations={resiliation?.contrat}
              label="Etape 2 : Identification du contrat"
              goToStep={() => goToStep(1)}
            />
            <EditComponent
              informations={resiliation?.motifMaintenant}
              label="Etape 3 : Motif de la demande"
              goToStep={() => goToStep(2)}
              choixResiliation={motif[resiliation?.choixResil.choixResiliation]}
            />
          </div>
          <Formik
            initialValues={resiliation.recap}
            validationSchema={recapSchema}
            onSubmit={(values) => {
              submit({ ...resiliation, ...{ recap: { ...values } } });
            }}
          >
            {({ values, errors, touched, submitCount, handleChange, setFieldValue, setFieldTouched, ...props }) => {
              return (
                <div>
                  <Form>
                    <div className='row' style={{ height: 60 }}>
                      <div className="col-12">
                        {recaptcha && <SpbRecaptcha
                          recaptcha={recaptcha}
                          handleChange={(token: string) => {
                            setFieldValue("recaptcha", token);
                          }}
                          touched={submitCount > 0}
                          error={errors.recaptcha}
                        />
                        }
                      </div>
                    </div>

                    <FormulaireSubmit inProgress={inProgress} previous={() => cancel()} recap={true} />
                  </Form>
                </div>
              )
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};